<template>
  <div class="about container">
    <div class="form-group">
      <label class="font-weight-bold" for="title">Title:</label>
      <input type="text" class="form-control" v-model="localNote.title">
    </div>
    <div class="form-group">
      <label class="font-weight-bold" for="description">Description:</label>
      <input type="text" class="form-control" v-model="localNote.description">
    </div>
    <button class="btn btn-success form-control" :disabled="localNote.title.length == 0 || localNote.description.length == 0" @click="addNote2">Save</button>
  </div>
</template>

<script>
export default {
  name: 'CreateNote',
   data() {
    return {
      localNote: {
        title: '',
        description: '',
        author: 'Carlos Mercado'
      },
      errored: false
    }
  },
  methods: {
    async addNote2() {
      var datos = new FormData();
      datos.append("title", this.localNote.title);
      datos.append("description", this.localNote.description);
      datos.append("author", this.localNote.author);
      //send data
      try {
        let response = await fetch('http://cronos8studio.com/cronos/php/addNote.php', {
          method: 'POST',
          body: datos
        })
        //response
        if(response){
            let jsonResponse = await response.json();
            console.log(jsonResponse);
            this.showAlert('success', 'Well done!', 'home');
            this.localNote.title = '';
            this.localNote.description = '';
        }
      } catch(error) {
        console.log(error);
      }
    },
    addNote() {
      this.$store.dispatch('addNoteAction', this.localNote).then(() => {
        this.showAlert('success', 'Well done!', 'home'); 
      });
    },
    showAlert(icon, text, location) {
      Swal.fire({
          icon: icon,
          title: text,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push(location);
        }
      });
    }
  }
}
</script>